<template>
  <div class="view-catalog-list__categories">
    <div
      v-for="category in catalog.categories" 
      :key="category.id"
      class="view-catalog-list__category category">
      
      <header class="category__header">
        <h2 class="category__title">{{ category.name }}</h2>
        <p 
          v-if="category.description"
          class="category__description">{{ category.description }}</p>
      </header>

      <div class="category__body">
        <ul class="category__products">
          <li 
            v-for="product in category.products"
            :to="{ name: 'sayl-oat-catalog.product', params: {product: product.id}}"
            :key="product.id"
            class="category__product">

            <router-link
              :to="{ name: 'sayl-oat-catalog.product', params: {product: product.id}}"
              :key="product.id"
              class="card-product">

              <figure 
                class="card-product__figure"
                :class="{ '-no-figure': product.figures.length === 0 }">
                <img
                  v-if="product.figures.length"
                  class="card-product__illustration"  
                  :src="product.figures[0]" 
                  alt="awesome product">
              </figure>

              <div class="card-product__body">
                <div class="card-product__row">
                  <div class="card-product__title">{{ product.name }}</div>
                  <!-- <div class="card-product__price">{{ $n(product.price, 'currency') }}</div> -->
                  <div class="card-product__price">{{ formatProductPrice(product.price) }}</div>
                </div>

                <div class="card-product__row">
                  <p class="card-product__description">{{ product.description }}</p>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PriceMixin from '@/modules/catalog/mixins/price'

export default {
  name: 'CatalogCategories',
  
  mixins: [
    PriceMixin
  ],

  computed:{
    ...mapState({
      catalog: state => state['sayl-oat'].catalog,
      products: state => state.bootstrap.catalog.products
    })
  },

  methods:{
    formatProductPrice(price){
      let ret = this.toCurrency({value: price.value});

      if (price.min && price.max){
        ret = this.toRangeCurrency({min: price.min, max: price.max})
      }

      return ret;
    },
  }
}
</script>
